import * as React from 'react';
import { styled } from '@mui/material/styles';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Collapse from '@mui/material/Collapse';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { red } from '@mui/material/colors';
import FavoriteIcon from '@mui/icons-material/Favorite';
import ShareIcon from '@mui/icons-material/Share';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Style from '../Styles/ProductsStyle'
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import Settings from '../../../Settings/Settings';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';

export default function Product(props) {
  const classes = Style();
  const [quantity, setQuantity] = React.useState(0)
  const [showFullEquipment, setShowFullEquipment] = React.useState(false)
  const [inStock, setInStock] = React.useState(props.product.shopProductsStock == 'in stoc' || props.product.shopProductsStock == 'stoc limitat')
  const componentConstants = {
      ...props.componentConstants
  }

  const componentMethods = {
      ...props.componentMethods
  }

  const componentProps = {
      ...props.componentProps
  }
  let stockColor = 'red'
  if(props.product.shopProductsStock == 'in stoc') {
    stockColor = 'green'
  }
  if(props.product.shopProductsStock == 'stoc limitat') {
    stockColor = 'orange'
  }

  const postShoppingCartItemsAction = () => {
    let url = Settings.API_URL + Settings.API_ENDPOINT_SHOPPINGCARTITEMS + componentMethods.getLocalStorage('shoppingCart').shoppingCartSha
    let accountToken = ''
    if(componentMethods.getLocalStorage('user') && componentMethods.getLocalStorage('user').tokensHash) {
      accountToken = '?accountToken=' + componentMethods.getLocalStorage('user').tokensHash
    }
    let dataObject = {
      shoppingCartItemsShopProductsID: props.product.shopProductsID,
      shoppingCartItemsQuantity: quantity
    }

    url += accountToken
    componentMethods.ajax (
      url, 
      dataObject, 
      'POST', 
      true, 
      (data) => {
          if(componentMethods.addError) componentMethods.addError(componentConstants.language.LANG_ITEM_ADDED_TO_CART)
          componentMethods.setManagerState({showAddedToCartDialog: true})
          getShoppingCartTotal()
      }, 
      {}, 
      false, 
      () => {
        componentMethods.addError(componentConstants.language.LANG_ITEM_NOT_ADDED_TO_CART)
      })
  }

  const getShoppingCartTotal = () => {
    let accountToken = ''
    if(componentMethods.getLocalStorage('user')) {
        accountToken = '?accountToken=' + componentMethods.getLocalStorage('user').tokensHash;
    }
    componentMethods.ajax(Settings.API_URL + Settings.API_ENDPOINT_SHOPPINGCART_TOTAL + componentMethods.getLocalStorage('shoppingCart').shoppingCartSha + accountToken, {},'GET','addresses', (data) => {
        componentMethods.setManagerState({shoppingCartTotal: data.items.total})
    })
  }
  return (
    <Card sx={{ maxWidth: 345 }} style={classes.productContainer}>
      <CardHeader
        title={<Typography variant="h6" color="text.primary">{props.product.shopProductsArticleName}</Typography>}
        subheader={<Typography variant="body2" color="text.secondary">{props.product.shopProductsCategory} / {props.product.shopProductsBrand}</Typography>}
      />
      <CardContent>
        <div>
          <Typography variant="body2" color="text.secondary" component="span">
            {componentConstants.language.LANG_CODE_OEM}:&nbsp; 
          </Typography>
          <Typography variant="body2" color="text.primary" component="span">
            {props.product.shopProductsOemCode}
          </Typography>
        </div>
        <div>
          <Typography variant="body2" color="text.secondary" component="span">
            {componentConstants.language.LANG_EQUIPMENTS}:&nbsp; 
          </Typography>
          <Typography variant="body2" color="text.primary" component="span">
            {props.product.shopProductsEquipmentList.length > 67 && !showFullEquipment ?
              <React.Fragment>
                {props.product.shopProductsEquipmentList.substring(0, 66)}
                <IconButton aria-label="delete" onClick={(e) => {setShowFullEquipment(!showFullEquipment)}} >
                  <MoreHorizIcon />
                </IconButton>
              </React.Fragment>
              :
              <React.Fragment>
                {props.product.shopProductsEquipmentList.length > 67 ?
                  <React.Fragment>
                    <React.Fragment>
                      {props.product.shopProductsEquipmentList}
                    </React.Fragment>
                      <IconButton aria-label="delete" onClick={(e) => {setShowFullEquipment(!showFullEquipment)}} >
                      <MoreHorizIcon />
                    </IconButton>
                  </React.Fragment>
                  :
                  props.product.shopProductsEquipmentList
                }
              </React.Fragment>
            }
          </Typography>
        </div>
        <div>
          <Typography variant="body2" color="text.secondary" component="span">
            {componentConstants.language.LANG_PRICE}:&nbsp; 
          </Typography>
          <Typography variant="h6" color="text.primary" component="span">
            {parseInt(props.product.shopProductsListPriceConverted) / 100} {componentConstants.language.LANG_CURRENCY}
          </Typography>
        </div>
        <div>
          <Typography variant="body2" color="text.secondary" component="span">
            {componentConstants.language.LANG_STOCK}:&nbsp; 
          </Typography>
          <Typography variant="body2" style={{color: stockColor}} component="span">
            {props.product.shopProductsStock}
          </Typography>
        </div>
        <div>
          <TextField
          fullWidth
            label={componentConstants.language.LANG_INSERT_QUANTITY}
            type="search"
            variant="standard"
            onChange={(e)=> {setQuantity(e.target.value)}}
            disabled = {!inStock}
          />
        </div>
        <div>
          <Typography variant="body2" color="text.secondary" component="span">
            {componentConstants.language.LANG_SUBTOTAL}:&nbsp;
          </Typography>
          <Typography variant="h6" color="secondary" component="span">
              {(parseInt(props.product.shopProductsListPriceConverted) / 100 * quantity).toFixed(2)} {componentConstants.language.LANG_CURRENCY}
          </Typography>
        </div>
        <Button color="secondary" variant="contained" onClick={postShoppingCartItemsAction} fullWidth startIcon={<AddShoppingCartIcon />}>{componentConstants.language.LANG_ADD_TO_SHOPPING_CART}</Button>
      </CardContent>
      <CardActions disableSpacing>
      </CardActions>
    </Card>
  );
}